import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../../components/Layout';
import Content from '../../../components/Pages/Marathons/Update';

const { displayName } = config;

function MarathonUpdate(): React.JSX.Element {
  document.title = `${displayName}: Редактировать марафон`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
}

export default MarathonUpdate;
